// extracted by mini-css-extract-plugin
export default {"root":"Header_root__SqGIp","link":"Header_link__gQn7e","title":"Header_title__OcTD2","disabledLink":"Header_disabledLink__Hwo+u"};